module.exports = {
  background: '#fbf9f8',
  backgroundDark: '#f0e6f6',

  text: '#333333',

  primary: '#1f1d1f',
  primaryLight: '#1f1d1f',
  primaryDark: '#a38465',

  secondary: '#a393a0',
  secondaryLight: '#9d8d99',
  secondaryDark: '#3d3b47',
};
